import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// icons
import PlusIcon from '@mui/icons-material/Add'
import IconButton from '@mui/material/IconButton'
// constants
import { Forms } from 'constants/forms'
// types
import { FilterField } from '../../index'
import { PlanFilterField } from 'hooks/plans/usePlanFilterFields'
// themes
import { colors } from 'themes/index'
// components
import { ReduxRadioGroup } from 'components/FormElements'
// views
import { ArrowIcon, FieldSettingsWrapper, IconWrapper, FieldLabel } from './views'
// utils
import { getOptions, getValueField } from '../../utils'

interface Props {
  field: PlanFilterField
  addField: (field: FilterField) => void
  clearField: () => void
}

const selector = formValueSelector(Forms.PLAN_FILTER_FORM)

const Field: React.FC<Props> = ({ field, addField, clearField }) => {
  const value = useSelector((state) => selector(state, `${field.id}.value`))
  const action = useSelector((state) => selector(state, `${field.id}.action`))

  const onAddClick = () => {
    addField({
      value,
      action,
      id: field.id,
      name: field.label,
      entityName: field.entityName,
      fieldType: field.fieldType,
      ...(field.standard && { systemName: field.name })
    })
  }

  return (
    <FieldSettingsWrapper>
      <IconWrapper>
        <ArrowIcon onClick={clearField} htmlColor={colors.purple400} />
      </IconWrapper>
      <FieldLabel>{field.label}</FieldLabel>
      <ReduxRadioGroup name={`${field.id}.action`} options={getOptions(field)} />
      {getValueField({ field, name: `${field.id}.value`, responseTypeSets: [] })}
      <IconButton onClick={onAddClick} disabled={!value || !action}>
        <PlusIcon htmlColor={!value || !action ? colors.gray280 : colors.purple400} />
      </IconButton>
    </FieldSettingsWrapper>
  )
}

export default Field
